export enum ImportMemberExcelHeaderEnum {
  MemberNr = 'memberNr',
  FirstName = 'firstName',
  LastName = 'lastName',
  COAddress = 'COAddress',
  Address = 'address',
  ZipCode = 'zipcode',
  City = 'city',
  Gender = 'gender',
  BirthDate = 'birthdate',
  Phone = 'phone',
  PhoneOther = 'phoneOther',
  Email = 'email',
  AdmissionDate = 'admissionDate',
  ExpireDate = 'expireDate',
  Profiles = 'profiles',
}
